import React from "react";
import { CgCheck } from "react-icons/cg";
import cn from "../../lib/cn";

const Stepper = ({
    currentStep,
    onClick = () => {},
    theme = "light",
    steps = [],
    showCurrentStep = true,
    className,
}) => {
    const isDarkMode = theme === "dark";

    return (
        <div className={cn(`flex items-start w-full md:mb-2`, className)}>
            {steps.map((title, index) => (
                <React.Fragment key={index}>
                    <Step
                        title={title}
                        stepNumber={index + 1}
                        currentStep={currentStep}
                        onClick={onClick}
                        theme={theme}
                        showCurrentStep={showCurrentStep}
                    />
                    {index < steps.length - 1 && (
                        <hr
                            className={`w-full mt-1 ${
                                isDarkMode ? "bg-white" : ""
                            }`}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

const Step = ({
    title,
    stepNumber,
    currentStep,
    onClick,
    theme,
    showCurrentStep,
}) => {
    const isDarkMode = theme === "dark";
    const isActive = currentStep === stepNumber;

    return (
        <div
            className="flex flex-col flex-1 items-center gap-1"
            role="button"
            onClick={() => onClick(stepNumber)}
        >
            <div
                className={`w-[20px] h-[20px] rounded-full flex items-center justify-center border-[1.5px] ${
                    isActive
                        ? isDarkMode
                            ? "text-primary bg-white border-transparent"
                            : " bg-primary text-white border-primary"
                        : "text-secondary border-gray-500"
                } ${
                    currentStep >= stepNumber && !showCurrentStep
                        ? isDarkMode
                            ? " bg-white text-primary border-transparent"
                            : "bg-primary  text-white border-primary"
                        : "bg-white !text-primary"
                }`}
            >
                {currentStep <= stepNumber ? (
                    !showCurrentStep && isActive ? (
                        <CgCheck size={18} />
                    ) : (
                        stepNumber
                    )
                ) : (
                    <CgCheck size={18} />
                )}
            </div>
            <span
                className={`text-center sm:text-nowrap ${
                    isActive || currentStep > stepNumber
                        ? isDarkMode
                            ? "text-white"
                            : "text-primary"
                        : "text-gray-500"
                }`}
            >
                {title}
            </span>
        </div>
    );
};

export default Stepper;
